export default ['Richard Saghian, CEO', 'Catherine Morisano, CMO'];
